import React from 'react';
import { withEditMode } from '_containers/BaseComponent';
import { EditorWrapper, Rule } from './StyledDivider';
import PropTypes from 'prop-types';

const Divider = ({ editMode }) => 
  editMode ? (
    <EditorWrapper>
      <Rule />
    </EditorWrapper>
  ) : (
    <Rule />
  );

Divider.propTypes = {
  editMode: PropTypes.bool.isRequired,
};

export default withEditMode(Divider);
